import { css } from "theme/default/css";

export const setFlexDFAIC = css`
  display: flex;
  align-items: center;
`;
